export function normalizePersonName(value) {
  if (typeof value !== 'string' || value.toLowerCase() === value.toUpperCase()) return value;
  if (value !== value.toUpperCase() && value !== value.toLowerCase()) return value;
  return value.toLowerCase().replace(/\p{L}[\p{L}\p{M}]*/gu, word => word[0].toUpperCase() + word.slice(1));
}
